import { isDefined, uid } from "../../helpers";
import { getNextTaskId } from "../../actions/task/common";
export default function (store, { id, project, parent, targetId, task = {}, reverse, }) {
    if (store.existsTask(id)) {
        return;
    }
    const state = store.getState();
    const { activeProject, tasksMap } = state;
    task.id = id ?? task.id ?? uid().toString();
    if (typeof project !== "undefined") {
        task.project = project;
    }
    else if (typeof task.project === "undefined" &&
        isDefined(activeProject)) {
        task.project = activeProject;
    }
    if (typeof parent !== "undefined") {
        task.parent = parent;
    }
    if (!task.creation_date) {
        task.creation_date = new Date();
    }
    if (typeof task.text == "undefined") {
        task.text = "";
    }
    let { tasks } = state;
    tasksMap[id] = task;
    tasks = [...tasks, task];
    const { treeTasks, childrenMap, filteredChildrenMap, usersMap, tags } = store.getInnerState(tasks, activeProject);
    store.setState({
        tasks,
        treeTasks,
        childrenMap,
        filteredChildrenMap,
        usersMap,
        tags,
        tasksMap,
    });
    if (isDefined(targetId) || reverse) {
        store.moveTask({
            id: task.id,
            parent: task.parent,
            project: task.project,
            targetId,
            reverse,
            silent: true,
        });
    }
    return () => {
        const stateEditableItem = store.getState().stateEditableItem;
        if (stateEditableItem) {
            store.in.exec("close-inline-editor", {
                id: stateEditableItem.id,
                save: false,
            });
        }
        const nextSelect = getNextTaskId({ store, id });
        store.in.exec("delete-task", { id, $meta: { skipHistory: true } });
        store.in.exec("select-task", {
            id: nextSelect,
        });
    };
}
//# sourceMappingURL=add.js.map